"use client";

import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import './DatePickerPadrao.css';
import 'react-datepicker/dist/react-datepicker.css';
import { FaRegCalendarAlt } from 'react-icons/fa';

registerLocale('pt-BR', ptBR);

const DatePickerPadrao = ({
    children,
    selected,
    onChange = () => {},
    error,
    required = false,
    placeholder = "Selecione uma data",
    icon = null,
    cresce100 = false,
    dateFormat = "dd/MM/yyyy",
    minDate,
    maxDate,
    disabled = false,
    tamanhoGrande = false, // Nova prop para controlar o tamanho grande
    className = "",
    style = {},
    ...props
}) => {
    const [isFocused, setIsFocused] = useState(false);

    // CustomInput com modificações para garantir que o valor seja exibido
    const CustomInput = forwardRef(({ value, onClick, onChange, placeholder, disabled }, ref) => (
        <div className="datepicker-input-wrapper">
            <input
                className={`datepicker-input ${error ? 'datepicker-input-error' : ''} ${isFocused ? 'datepicker-input-focused' : ''} ${tamanhoGrande ? 'datepicker-input-grande' : ''}`}
                onFocus={(e) => {
                    setIsFocused(true);
                    onClick(e); // Abre o calendário no foco
                }}
                onChange={onChange}
                value={value || ''}
                placeholder={placeholder}
                ref={ref}
                readOnly
                disabled={disabled}
                onBlur={() => setIsFocused(false)}
            />
            <div className="datepicker-calendar-icon-wrapper" onClick={disabled ? undefined : onClick}>
                <FaRegCalendarAlt className="datepicker-calendar-icon" />
            </div>
        </div>
    ));
    
    CustomInput.displayName = 'CustomInput';

    return (
        <div
            className={`datepicker-container ${!cresce100 ? 'datepicker-nao-cresce' : ''} ${className}`}
        >
            {children && (
                <label 
                    className={`datepicker-label ${error ? 'datepicker-label-error' : ''} ${selected ? 'datepicker-label-preenchido' : ''}`}
                    htmlFor={props.id || ''}
                >
                    {icon && <FaRegCalendarAlt className="datepicker-icon" />}
                    {children}
                    {required && <span className="datepicker-required-indicator">*</span>}
                </label>
            )}
            <DatePicker
                selected={selected}
                onChange={(date) => {
                    onChange(date);
                    setIsFocused(false);
                }}
                dateFormat={dateFormat}
                locale="pt-BR"
                placeholderText={placeholder}
                customInput={<CustomInput />}
                minDate={minDate}
                maxDate={maxDate}
                disabled={disabled}
                showPopperArrow={false}
                popperClassName="datepicker-popper"
                shouldCloseOnSelect={true}
                calendarClassName="datepicker-calendar"
                dayClassName={() => "datepicker-day"}
                monthClassName={() => "datepicker-month"}
                yearClassName={() => "datepicker-year"}
                onCalendarClose={() => setIsFocused(false)}
                {...props}
            />
            {error && <span className="datepicker-error-message">{error}</span>}
        </div>
    );
};

DatePickerPadrao.propTypes = {
    children: PropTypes.node,
    selected: PropTypes.instanceOf(Date),
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    icon: PropTypes.node,
    cresce100: PropTypes.bool,
    dateFormat: PropTypes.string,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    disabled: PropTypes.bool,
    tamanhoGrande: PropTypes.bool // Validação da nova prop
};

DatePickerPadrao.defaultProps = {
    required: false,
    cresce100: false,
    placeholder: "Selecione uma data",
    dateFormat: "dd/MM/yyyy",
    disabled: false,
    tamanhoGrande: false // Valor padrão da nova prop
};

export default DatePickerPadrao;
